export default class EnderecoDTO {
    id: number = 0;
    street: string = '';
    number: string = '';
    country: string = '';
    complement: string = '';
    city: string = '';
    uf: string = '';
    pais: string = 'Brasil';
    cep: string = '';
}